import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'src/shared/modal';
import { MatchedOfferViewLogOverlayComponent } from './matched-offer-view-log-overlay.component';
import { MatchedOfferViewLogOverlayService } from './matched-offer-view-log-overlay.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuditLogModule } from 'src/components/audit-log/audit-log.module';

@NgModule({
  declarations: [MatchedOfferViewLogOverlayComponent],
  providers: [MatchedOfferViewLogOverlayService],
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    ModalModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    AuditLogModule
  ],
})
export class MatchedOfferViewLogOverlayModule {}
